module.exports = __webpack_public_path__ + "img/ezGolf-icon-tour.c2ad656f.svg";